import Vue from "vue";

import VueAxios from "vue-axios";
import VueAuthenticate from "vue-authenticate";

Vue.use(VueAxios, axios);

export default VueAuthenticate.factory(Vue.prototype.$http, {
  baseUrl: config.app.api_url, // Your API domain
  loginUrl: config.app.api_url + "/login"
});

const catchAuthFail = (response, store) => {
  if (response.status == 401 || response.status == 400) {
    store.dispatch("logoutOffline");
  }
};

export const handleAuth = store => {
  return new Promise((resolve, reject) => {
    if (store.getters.shouldRefreshToken) {
      return store
        .dispatch("refreshAccessToken")
        .then(() => {
          return store.dispatch("fetchUser").then(() => location.reload());
        })
        .catch(({response}) => {
          catchAuthFail(response, store);
          reject();
        });
    } else if (store.getters.isAuthenticated) {
      return store.dispatch("fetchUser").catch(e => {
        catchAuthFail(e, store);
        reject();
      });
    } else {
      return store.dispatch(
        "setAppearance",
        store.getters.appearance.toLowerCase()
      );
    }
  });
};
